import { createSlice } from "@reduxjs/toolkit";

const userRegistrationSlice = createSlice({
    name: "UserRegistration",
    initialState: {},
    reducers: {
        registerRequest(state) {
            state.registering = true;
            state.loading = true;
            state.errorMessage = null;
        },
        registerSuccess(state) {
            state.registering = false;
            state.success = true;
            state.modal = false;
            state.loading = false;
            state.errorMessage = null;
        },
        registerFailure(state, action) {
            state.registering = true;
            state.success = false;
            state.errorMessage = action.payload;
            state.loading = false;
        },
        registerWithAuthDataRequest(state) {
            state.subloading = true;
            state.registering = true;
        },
        registerWithAuthDataSuccess(state) {
            state.subloading = false;
            state.registering = false;
            state.success = true;
            state.successMessage = "Sie haben sich erfolgreich registriert.";
        },
        registerWithAuthDataFailure(state, action) {
            state.subloading = false;
            state.registering = false;
            state.success = false;
            state.errorMessage = action.payload;
        },
        autoLoginShopifyRequest(state) {
            state.registering = true;
            state.autoLoginLoading = true;
            state.errorMessage = null;
        },
        autoLoginShopifySuccess(state) {
            state.registering = false;
            state.autoLoginLoading = false;
            state.success = true;
        },
        autoLoginShopifyFailure(state, action) {
            state.registering = false;
            state.autoLoginLoading = false;
            state.success = false;
            state.errorMessage = action.payload;
        },

        autoLoginLexOfficeRequest(state) {
            state.errorMessage = null;
            state.loginLoading = true;
            state.autologinSuccess = false;
        },
        autoLoginLexOfficeSuccess(state) {
            state.success = true;
            state.errorMessage = null;
            state.loginLoading = false;
            state.autologinSuccess = true;
        },
        autoLoginLexOfficeFailure(state, action) {
            state.success = false;
            state.loginLoading = false;
            state.errorMessage = action.payload;
            state.autologinSuccess = true;
        },
    },
});

export default userRegistrationSlice;
